import { commitRender, cleanupAllEffects } from "./commit.js";
import { getDevStrictMode, withResourceFiber } from "./execution-context.js";
import { callResourceFn } from "./callResourceFn.js";
import { isDevelopment } from "./env.js";
export function createResourceFiber(type, dispatchUpdate, strictMode = getDevStrictMode(false)) {
    return {
        type,
        dispatchUpdate,
        devStrictMode: strictMode,
        cells: [],
        currentIndex: 0,
        renderContext: undefined,
        isFirstRender: true,
        isMounted: false,
        isNeverMounted: true,
    };
}
export function unmountResourceFiber(fiber) {
    if (!fiber.isMounted)
        throw new Error("Tried to unmount a fiber that is already unmounted");
    fiber.isMounted = false;
    cleanupAllEffects(fiber);
}
export function renderResourceFiber(fiber, props) {
    const result = {
        commitTasks: [],
        props,
        output: undefined,
    };
    withResourceFiber(fiber, () => {
        fiber.renderContext = result;
        try {
            result.output = callResourceFn(fiber.type, props);
        }
        finally {
            fiber.renderContext = undefined;
        }
    });
    return result;
}
export function commitResourceFiber(fiber, result) {
    fiber.isMounted = true;
    if (isDevelopment && fiber.isNeverMounted && fiber.devStrictMode === "root") {
        commitRender(result);
        cleanupAllEffects(fiber);
    }
    fiber.isNeverMounted = false;
    commitRender(result);
}
//# sourceMappingURL=ResourceFiber.js.map